import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-course', {
  key: 'admin-course',
  label: 'Courses Manager',
  getSteps: () => [
    introStep({
      title: 'Courses Manager',
      content:
        'The hub for everything course-related at a tertiary institution. Use the tabs to manage the course catalog, define curricula per programme, review school-wide course registrations, and approve exemptions.',
    }),
  ],
});

registerTourPage('course-details', {
  key: 'admin-course-details',
  label: 'Course Details',
  getSteps: () => [
    introStep({
      title: 'Course Profile',
      content:
        'Course code, title, units, and the lecturers teaching it this semester. Use the academic-calendar selector to switch which semester you\'re viewing.',
    }),
  ],
});
